import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';
import Plantillas from './Plantillas';
import PlantillasCoexistencia from './PlantillasCoexistencia';

const PlantillasRouter = () => {
  const [connectionMode, setConnectionMode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkConnectionMode();
  }, []);

  const checkConnectionMode = async () => {
    try {
      const response = await api.get('/integration/connection-status/');
      const isConnected = !!response.data.is_connected;
      const mode = response.data.mode || 'no_oficial';
      if (isConnected && mode === 'coexistencia') {
        setConnectionMode('coexistencia');
      } else {
        setConnectionMode('no_oficial');
      }
    } catch (err) {
      console.error('Error checking connection mode:', err);
      setConnectionMode('no_oficial');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '3rem', color: '#fff' }}>
        Verificando modo de conexión...
      </div>
    );
  }

  // Si está en modo coexistencia, usar PlantillasCoexistencia
  if (connectionMode === 'coexistencia') {
    return <PlantillasCoexistencia />;
  }

  // Si es no_oficial o no hay conexión, usar Plantillas normales
  return <Plantillas />;
};

export default PlantillasRouter;
